import React from 'react';
import { toLocaleCurrencyString } from '../Shared/utils';

function CryptoStrap(props) {
  const { topCoins: coins = [], baseCurrencySymbol } = props;

  return coins.map(({ name, current_price }, idx) => (
    <div className="cryptoTicker__coinItem" key={idx}>
      <span className="cryptoTicker__coinName">{name}</span> <strong className="cryptoTicker__coinValue">
        {toLocaleCurrencyString({
          fractionDigits: 2,
          currencySymbol: baseCurrencySymbol,
          value: parseFloat(current_price),
        })}
      </strong>
    </div>
  ));
}

export default CryptoStrap;



// WEBPACK FOOTER //
// ./src/CryptoStrap/index.js